import { listContractTypes } from './contractType';
import { ContractType, ContractTypeDTO } from './interfaces/contractType';

function normalizeBool(v: unknown): boolean {
  if (typeof v === 'boolean') return v;
  if (typeof v === 'number') return v === 1;
  if (typeof v === 'string') return v === '1' || v.toLowerCase() === 'true';
  return false;
}

let cache: ContractType[] | null = null;
let inflight: Promise<ContractType[]> | null = null;
let ts = 0;
const TTL = 5 * 60 * 1000;

export async function getContractTypesCached(
  force = false,
): Promise<ContractType[]> {
  const now = Date.now();

  if (!force && cache && now - ts < TTL) return cache;

  if (inflight) return inflight;

  inflight = listContractTypes()
    .then(({ data }) => {
      const raw: ContractTypeDTO[] = data?.results ?? [];
      const normalized: ContractType[] = raw.map((t) => ({
        ...t,
        has_unique_restriction: normalizeBool(t.has_unique_restriction),
      }));

      cache = normalized;
      ts = Date.now();
      inflight = null;
      return normalized;
    })
    .catch((err) => {
      inflight = null;
      throw err;
    });

  return inflight;
}
